(function () {
  var STORAGE_MOBILE = 'vivi-plp-cols-mobile';
  var STORAGE_DESKTOP = 'vivi-plp-cols-desktop';

  function grid() {
    return document.getElementById('product-grid');
  }

  function toolbarRoot() {
    return document.querySelector('[data-vivi-plp-toolbar]');
  }

  function clearColClasses(el) {
    if (!el) return;
    el.className = el.className
      .split(/\s+/)
      .filter(function (c) {
        return c && !/^vivi-plp-cols-/.test(c);
      })
      .join(' ');
  }

  function applyCols(mobileCols, desktopCols) {
    var el = grid();
    if (!el) return;
    clearColClasses(el);
    el.classList.add('vivi-plp-cols-' + mobileCols);
    el.classList.add('vivi-plp-cols-desktop-' + desktopCols);
    try {
      localStorage.setItem(STORAGE_MOBILE, String(mobileCols));
      localStorage.setItem(STORAGE_DESKTOP, String(desktopCols));
    } catch (err) {}
  }

  function syncButtons(mobileCols, desktopCols) {
    var root = toolbarRoot();
    if (!root) return;
    root.querySelectorAll('[data-vivi-grid-mobile]').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.getAttribute('data-vivi-grid-mobile') === String(mobileCols));
    });
    root.querySelectorAll('[data-vivi-grid-desktop]').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.getAttribute('data-vivi-grid-desktop') === String(desktopCols));
    });
  }

  function currentCols() {
    var mobile = 2;
    var desktop = 4;
    try {
      mobile = parseInt(localStorage.getItem(STORAGE_MOBILE) || '2', 10) || 2;
      desktop = parseInt(localStorage.getItem(STORAGE_DESKTOP) || '4', 10) || 4;
    } catch (err) {}
    if ([1, 2, 3].indexOf(mobile) === -1) mobile = 2;
    if ([2, 3, 4].indexOf(desktop) === -1) desktop = 4;
    return { mobile: mobile, desktop: desktop };
  }

  function initGrid() {
    var cols = currentCols();
    applyCols(cols.mobile, cols.desktop);
    syncButtons(cols.mobile, cols.desktop);
  }

  function onToolbarClick(event) {
    var btn = event.target.closest('[data-vivi-grid-mobile], [data-vivi-grid-desktop]');
    if (!btn || !toolbarRoot() || !toolbarRoot().contains(btn)) return;
    event.preventDefault();
    var cols = currentCols();
    if (btn.hasAttribute('data-vivi-grid-mobile')) {
      cols.mobile = parseInt(btn.getAttribute('data-vivi-grid-mobile'), 10) || cols.mobile;
    }
    if (btn.hasAttribute('data-vivi-grid-desktop')) {
      cols.desktop = parseInt(btn.getAttribute('data-vivi-grid-desktop'), 10) || cols.desktop;
    }
    applyCols(cols.mobile, cols.desktop);
    syncButtons(cols.mobile, cols.desktop);
  }

  function initSort() {
    document.querySelectorAll('details.vivi-sort').forEach(function (details) {
      if (details.dataset.viviSortBound === '1') return;
      details.dataset.viviSortBound = '1';
      details.addEventListener('toggle', function () {
        if (!details.open) return;
        document.querySelectorAll('details.vivi-sort[open]').forEach(function (other) {
          if (other !== details) other.removeAttribute('open');
        });
      });
      details.addEventListener('change', function () {
        details.removeAttribute('open');
      });
    });
  }

  function boot() {
    if (!toolbarRoot()) return;
    initGrid();
    initSort();
  }

  document.addEventListener('click', onToolbarClick);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Re-apply after Dawn facet section morphs */
  var bootTimer;
  var observer = new MutationObserver(function () {
    window.clearTimeout(bootTimer);
    bootTimer = window.setTimeout(boot, 50);
  });
  document.addEventListener('DOMContentLoaded', function () {
    ['ProductGridContainer', 'main-collection-filters'].forEach(function (id) {
      var node = document.getElementById(id);
      if (node) observer.observe(node, { childList: true, subtree: true });
    });
  });
})();
